import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AuthImage from "../components/AuthImage";

/**
 * Editorial figure — sizing comes from CSS role modifiers.
 */
export function EditorialImage({
  src,
  description = "",
  role = "inline",
  className = "",
  lightbox = true,
  imgClassName = "",
}) {
  const [open, setOpen] = useState(false);
  const label = description || "Photo";
  const roleClass = `editorial-image--${role}`;

  return (
    <>
      <figure
        className={`editorial-image ${roleClass} ${className}`.trim()}
        onClick={lightbox ? () => setOpen(true) : undefined}
      >
        <AuthImage src={src} alt={label} className={imgClassName} />
        {description ? <figcaption>{description}</figcaption> : null}
      </figure>

      {lightbox ? (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullScreen
          PaperProps={{ sx: { bgcolor: "rgba(0,0,0,0.92)", m: 0 } }}
        >
          <IconButton
            aria-label="Close"
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8, zIndex: 1, color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              padding: 16,
              boxSizing: "border-box",
            }}
            onClick={() => setOpen(false)}
          >
            <div
              style={{ position: "relative", maxWidth: "100%", maxHeight: "100%" }}
              onClick={(e) => e.stopPropagation()}
            >
              <AuthImage
                src={src}
                alt={label}
                style={{
                  display: "block",
                  maxWidth: "100vw",
                  maxHeight: "100vh",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
              {description ? (
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    padding: "12px 16px",
                    background: "linear-gradient(transparent, rgba(0,0,0,0.75))",
                    color: "#fff",
                    fontFamily: "system-ui, sans-serif",
                    fontSize: "0.9rem",
                  }}
                >
                  {description}
                </div>
              ) : null}
            </div>
          </div>
        </Dialog>
      ) : null}
    </>
  );
}

export default EditorialImage;
